import NumbersField from "../components/number-fields/numbers-field";
import { FormProps, InputTypes } from "../components/textFieldProps";
import MoneyField from "../components/money-fields/money-field";
import DateField from "../components/date-fields/date-field";
import SelectField from "../components/select-field/select-field";
import ciudades from "app/analista/detalle-solicitud/interfaces/components/scoring/components/select-field/utilities/ciudades";

export default function FormularioDatosDelCliente({formulario, setFormulario, editable}: {formulario : any, setFormulario : any, editable: boolean}) {

    return (
        <div className="mb-32">  
            <div className="flex grid grid-cols-2 gap-4">
                <MesesIncorporacion model={formulario} setModel={setFormulario} editable={editable}/>
                <div className="mt-9">
                    <MesesExperienciaSector model={formulario} setModel={setFormulario} editable={editable}/>
                </div>
            </div>
            <div className="flex grid grid-cols-2 gap-4 mt-8">
                <IngresosReportados model={formulario} setModel={setFormulario} editable={editable}/>
                <div className="mt-9">
                    <IngresosPorExtractos model={formulario} setModel={setFormulario} editable={editable}/>      
                </div>
            </div>
            <div className="flex grid grid-cols-2 gap-4 mt-8">
                <ExperienciaMontos model={formulario} setModel={setFormulario} editable={editable}/>
                <CiudadCliente model={formulario} setModel={setFormulario} editable={editable}/> 
            </div>
        </div>
    );
}

const MesesIncorporacion = ({ model, setModel, editable }: FormProps) => {

    const placeholderText = model?.tipodepersona === "Persona jurídica" ? "Fecha de constitución" : "Fecha inicio de actividad";

    return (
        <DateField
            model={model}
            setModel={setModel}
            campoId='date_of_incorporation'
            campoIdRespuesta='months_of_incorporation'
            title={'Tiempo de experiencia'}
            tooltip={<>Inicio de actividad: Tiempo promedio que el cliente lleva en su actividad actual. Se autocompletará con el valor ingresado en FinMaq Go.<br></br><br></br>Meses de experiencia en el sector: Total de meses trabajados en el sector, incluyendo experiencia en diferentes roles. Se autocompletará con el valor ingresado en FinMaq Go.</>}
            placeholder={placeholderText}
            type={InputTypes.Date}
            editable={editable}
        />
    )
};

const MesesExperienciaSector = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {

    return(
        <NumbersField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='months_of_incorporation'  
            campoIdRespuesta={'score_arrears'}
            placeholder={'Meses de experiencia en el sector'}
            tooltip={<>Inicio de actividad: Tiempo promedio que el cliente lleva en su actividad actual. Se autocompletará con el valor ingresado en FinMaq Go.<br></br><br></br>Meses de experiencia en el sector: Total de meses trabajados en el sector, incluyendo experiencia en diferentes roles. Se autocompletará con el valor ingresado en FinMaq Go.</>}
            type={InputTypes.Number}
            min={0}
            editable={editable}
        />

        
    )
}

const IngresosReportados = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <MoneyField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='preapproved_incomes'
            campoIdRespuesta='incomes_score'
            title={'Ingresos por extractos'}
            placeholder={
                <>
                    <div className="flex">
                        <div>
                        Ingresos mensuales aproximados
                        </div>
                        <div className="relative group inline-block ml-1 mt-0.5">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="cursor-pointer"
                            >
                                <path
                                    d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="absolute text-center z-50 hidden group-hover:block top-full mt-2 left-7 -translate-x-1/2 px-3 py-2 bg-[#171923] text-white text-sm rounded-lg shadow-lg max-w-[412px] w-max break-words" >
                                Valor diligenciado en el campo de Ingresos Mensuales<br></br> Aproximados de Pre-Aprobados
                            </div>
                        </div>
                    </div>
                </>
            }
            type={InputTypes.Money}
            editable={editable}
        />
    )
}

const IngresosPorExtractos = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <MoneyField
            model={formulario}
            required={true}
            setModel={setFormulario}
            campoId='incomes_extracts'
            placeholder={
                <>
                    <div className="flex">
                        <div>
                            Promedio mensual (últimos 3 meses)
                        </div>
                        <div className="relative group inline-block ml-1 mt-0.5">
                            <svg
                                width="16"
                                height="16"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                className="cursor-pointer"
                            >
                                <path
                                    d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                            <div className="absolute text-center z-50 hidden group-hover:block top-full mt-2 left-7 -translate-x-1/2 px-3 py-2 bg-[#171923] text-white text-sm rounded-lg shadow-lg max-w-[412px] w-max break-words" >
                                Promedio del valor expuesto en los extractos bancarios <br></br>y/o recibos de los últimos tres meses
                            </div>
                        </div>
                    </div>
                </>
            }
            type={InputTypes.Money}
            editable={editable}
        />
    )
}

const ExperienciaMontos = ({model: formulario, setModel : setFormulario, editable} : FormProps) => {
    
    return (
        <MoneyField
        model={formulario}
        required={true}
        setModel={setFormulario}
        campoId='transunion_amounts'
        campoIdRespuesta='amounts_score'
        placeholder='Valor en experiencias similares'
        title={'Experiencia en montos similares'}
        tooltip={<>Valor aproximado de las obligaciones ya saldadas o en caso de no tenerlas, <br></br>es posible tomarlo de las obligaciones vigentes. <br></br>Consulta el PDF de Información comercial de TransUnion en la sección<br></br>de Informe detallado</>}
        type={InputTypes.Money}
        min={0}
        editable={editable}
        />
    )
}

const CiudadCliente = ({ model: formulario, setModel: setFormulario, editable }: FormProps) => {
  return (
    <SelectField
      required={true}
      model={formulario}
      setModel={setFormulario}
      campoId="department"
      campoIdRespuesta="department_score"
      type={InputTypes.Text}
      placeholder="Departamento"
      title={'Ubicación'}
      tooltip={'Opción seleccionada en el formulario de FinMaq Go'}
      editable={editable}
      options={ciudades}
    ></SelectField>
  )
}
